import { Fragment, useState } from 'react'
import './index.css'

const TruncatedTextComponent = ({
  text,
  maxChars = 150, // Default to 150 if not provided
}: {
  text: string
  maxChars?: number
}) => {
  const [isExpanded, setIsExpanded] = useState(false) // Tracks whether the text is expanded

  const toggleTextState = () => setIsExpanded(true) // Expand to full text on click

  const isTruncated = text.length > maxChars

  const displayText = isExpanded ? text : text.slice(0, maxChars)

  return (
    <p style={{ display: 'inline' }}>
      {displayText.split('\n').map((line, index, arr) => (
        <Fragment key={index}>
          {line}
          {index < arr.length - 1 && <br />}
        </Fragment>
      ))}
      {isTruncated && !isExpanded && (
        <span>
          {'... '}
          <button
            onClick={toggleTextState}
            className='text-primary hover:underline text-sm font-medium inline'
            style={{ display: 'inline', whiteSpace: 'nowrap' }}
          >
            More
          </button>
        </span>
      )}
    </p>
  )
}

export default TruncatedTextComponent
